var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlluser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.75C8.20507 1.75 6.75 3.20507 6.75 5C6.75 6.79493 8.20507 8.25 10 8.25C11.7949 8.25 13.25 6.79493 13.25 5C13.25 3.20507 11.7949 1.75 10 1.75ZM5.25 5C5.25 2.37665 7.37665 0.25 10 0.25C12.6234 0.25 14.75 2.37665 14.75 5C14.75 7.62335 12.6234 9.75 10 9.75C7.37665 9.75 5.25 7.62335 5.25 5Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 19C18.75 19.4142 18.4142 19.75 18 19.75H2C1.58579 19.75 1.25 19.4142 1.25 19V13.2857C1.25 12.3128 1.86243 11.5358 2.63588 11.0386C3.41736 10.5362 4.4517 10.25 5.55556 10.25H14.4444C15.5483 10.25 16.5826 10.5362 17.3641 11.0386C18.1376 11.5358 18.75 12.3128 18.75 13.2857V19ZM17.25 18.25V13.2857C17.25 12.9963 17.0664 12.6305 16.553 12.3004C16.0476 11.9755 15.3041 11.75 14.4444 11.75H5.55556C4.69586 11.75 3.95241 11.9755 3.44701 12.3004C2.93357 12.6305 2.75 12.9963 2.75 13.2857V18.25H17.25Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlluser);
export default __webpack_public_path__ + "static/media/alluser.e03a6245287e55e83394f43658e5b1fa.svg";
export { ForwardRef as ReactComponent };